import type { UseFormReturn } from "react-hook-form";

import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

const updatePasswordFormSchema = z.object({
  confirmPassword: z.string().min(1, "Please fill in this field."),
  password: z.string().min(1, "Please fill in this field."),
});

export type UpdatePasswordFormData = z.infer<typeof updatePasswordFormSchema>;

export function useUpdatePasswordForm(): UseFormReturn<UpdatePasswordFormData> {
  return useForm<UpdatePasswordFormData>({
    defaultValues: {
      confirmPassword: "",
      password: "",
    },
    resolver: zodResolver(updatePasswordFormSchema),
  });
}
